<script>
    import {ready, url} from "@sveltech/routify";
    import {apiFetch} from '../../../apiFetch';
    import Validations from '../../../components/graphs/Validations.svelte';
    import EventImage from "../../../components/event/EventImage.svelte";
    import Spinner from "../../../components/spinner/Spinner.svelte";

    export let campaignId;
</script>

{#await apiFetch('/campaigns/' + campaignId)}
    <Spinner/>
{:then data}
    {#each data.campaign.events as event }
        <EventImage event={ event }/>

        {#if event.game}
            <Validations campaignId={data.campaign.id}/>
        {:else}
            <button>START GAME!</button>
        {/if}
    {/each}
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}

<svelte:head>
    <title>Campaign</title>
</svelte:head>